import { dataFetcher } from 'core/services/requestHandler';   
import { format, parse } from 'date-fns';

export const getUserDetailsByMobile = (data = {}, config = {}) => {
  return dataFetcher('user/getUserSuggestionsByMobile', data, {...config});
};

export const getLibraries = async (data = {}, config = {}) => {
  return dataFetcher('properties/getLibraries', data, { ...config});
};

export const defaultTimeSlots = [
  {time: 0, label: '12:00 AM'}, {time: 1, label: '01:00 PM'}, {time: 2, label: '02:00 AM'}, {time: 3, label: '03:00 AM'},
  {time: 4, label: '04:00 AM'}, {time: 5, label: '05:00 AM'}, {time: 6, label: '06:00 AM'}, {time: 7, label: '07:00 AM'},
  {time: 8, label: '08:00 AM'}, {time: 9, label: '09:00 AM'}, {time: 10, label: '10:00 AM'}, {time: 11, label: '11:00 AM'},
  {time: 12, label: '12:00 PM'}, {time: 13, label: '01:00 PM'}, {time: 14, label: '02:00 PM'}, {time: 15, label: '03:00 PM'},
  {time: 16, label: '04:00 PM'}, {time: 17, label: '05:00 PM'}, {time: 18, label: '06:00 PM'}, {time: 19, label: '07:00 PM'},
  {time: 20, label: '08:00 PM'}, {time: 21, label: '09:00 PM'}, {time: 22, label: '10:00 PM'},{time: 23, label: '11:00 PM'}
];

export function getDBDateFormat(date) {
  return date ? format(date, 'dd-MM-yyyy') : date;
}

export function getDisplayDate(dateString) {
  const date = parse(dateString, 'dd-MM-yyyy', new Date())
  return date  ? format(date, 'MMMM dd, yyyy') : dateString;
}

export function formatTime(time){
  if(time){
    // Check correct time format and split into components
    let time1 = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    if (time1.length > 1) { // If time format correct
      time1 = time1.slice (1);  // Remove full string match value
      time1[5] = +time1[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
      time1[0] = +time1[0] % 12 || 12; // Adjust hours
    }
    return time1.join (''); // return adjusted time or original string
  }
  return time
}
